"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import DropsListItemDeleteDropModal from "@/components/drops/view/item/options/delete/DropsListItemDeleteDropModal";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import CommonDropdownItemsDefaultWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsDefaultWrapper";
import { getFileInfoFromUrl } from "@/helpers/file.helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { EllipsisHorizontalIcon } from "@heroicons/react/24/outline";
import { useContext, useMemo, useRef, useState } from "react";
import { Tooltip } from "react-tooltip";
import WaveDropActionsCopyLink from "./WaveDropActionsCopyLink";
import WaveDropActionsDownload from "./WaveDropActionsDownload";
import WaveDropActionsMarkUnread from "./WaveDropActionsMarkUnread";
import WaveDropActionsOpen from "./WaveDropActionsOpen";
import WaveDropActionsOptions from "./WaveDropActionsOptions";
import WaveDropActionsToggleLinkPreview from "./WaveDropActionsToggleLinkPreview";
interface WaveDropActionsMoreProps {
  readonly drop: ExtendedDrop;
  readonly onOpenChange?: (isOpen: boolean) => void;
}
export default function WaveDropActionsMore(t0) {
  const $ = _c(58);
  const {
    drop,
    onOpenChange
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const buttonRef = useRef(null);
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const {
    canDelete
  } = useDropInteractionRules(drop);
  const isAuthor = connectedProfile?.handle === drop.author.handle && !activeProfileProxy;
  let t1;
  if ($[0] !== onOpenChange) {
    t1 = newIsOpen => {
      setIsOpen(newIsOpen);
      onOpenChange?.(newIsOpen);
    };
    $[0] = onOpenChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOpenChange = t1;
  let t2;
  if ($[2] !== handleOpenChange) {
    t2 = () => handleOpenChange(false);
    $[2] = handleOpenChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const closeDropdown = t2;
  let t3;
  if ($[4] !== handleOpenChange) {
    t3 = () => {
      handleOpenChange(false);
      setIsDeleteModalOpen(true);
    };
    $[4] = handleOpenChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleDeleteClick = t3;
  let t4;
  if ($[6] !== drop.parts) {
    bb0: {
      const media = drop.parts.at(0)?.media.at(0);
      const url = media?.url;
      if (!url) {
        t4 = null;
        break bb0;
      }
      t4 = getFileInfoFromUrl(url);
    }
    $[6] = drop.parts;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const mediaInfo = t4;
  let t5;
  if ($[8] !== handleOpenChange || $[9] !== isOpen) {
    t5 = () => handleOpenChange(!isOpen);
    $[8] = handleOpenChange;
    $[9] = isOpen;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = `more-actions-${drop.id}`;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <EllipsisHorizontalIcon className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-transition tw-duration-300 tw-ease-out" />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isOpen || $[13] !== t5 || $[14] !== t6) {
    t8 = <button ref={buttonRef} className="tw-flex tw-h-7 tw-w-7 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-iron-400 tw-transition-all tw-duration-200 tw-ease-out desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-iron-200" onClick={t5} aria-label="More actions" aria-haspopup="true" aria-expanded={isOpen} data-tooltip-id={t6}>{t7}</button>;
    $[12] = isOpen;
    $[13] = t5;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== drop.id || $[17] !== isOpen) {
    t9 = !isOpen && <Tooltip id={`more-actions-${drop.id}`} place="top" offset={8} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    }}><span className="tw-text-xs">More</span></Tooltip>;
    $[16] = drop.id;
    $[17] = isOpen;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  let t11;
  let t12;
  if ($[19] !== closeDropdown || $[20] !== drop) {
    t10 = <WaveDropActionsMarkUnread drop={drop} isDropdownItem={true} onMarkUnread={closeDropdown} />;
    t11 = <WaveDropActionsCopyLink drop={drop} isDropdownItem={true} onCopy={closeDropdown} />;
    t12 = <WaveDropActionsOpen drop={drop} isDropdownItem={true} onOpen={closeDropdown} />;
    $[19] = closeDropdown;
    $[20] = drop;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t10 = $[21];
    t11 = $[22];
    t12 = $[23];
  }
  let t13;
  if ($[24] !== closeDropdown || $[25] !== drop.id || $[26] !== drop.parts || $[27] !== mediaInfo) {
    t13 = mediaInfo && <WaveDropActionsDownload href={drop.parts.at(0)?.media.at(0)?.url ?? ""} name={mediaInfo.name} extension={mediaInfo.extension} tooltipId={`download-media-${drop.id}`} isDropdownItem={true} onDownload={closeDropdown} />;
    $[24] = closeDropdown;
    $[25] = drop.id;
    $[26] = drop.parts;
    $[27] = mediaInfo;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== canDelete || $[30] !== drop || $[31] !== handleDeleteClick) {
    t14 = canDelete && <WaveDropActionsOptions drop={drop} isDropdownItem={true} onDelete={handleDeleteClick} />;
    $[29] = canDelete;
    $[30] = drop;
    $[31] = handleDeleteClick;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== closeDropdown || $[34] !== drop || $[35] !== isAuthor) {
    t15 = isAuthor && <WaveDropActionsToggleLinkPreview drop={drop} isDropdownItem={true} onToggle={closeDropdown} />;
    $[33] = closeDropdown;
    $[34] = drop;
    $[35] = isAuthor;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t12 || $[40] !== t13 || $[41] !== t14 || $[42] !== t15) {
    t16 = <li className="tw-list-none"><div className="tw-flex tw-flex-col tw-gap-y-1 tw-py-1">{t10}{t11}{t12}{t13}{t14}{t15}</div></li>;
    $[37] = t10;
    $[38] = t11;
    $[39] = t12;
    $[40] = t13;
    $[41] = t14;
    $[42] = t15;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== handleOpenChange || $[45] !== isOpen || $[46] !== t16) {
    t17 = <CommonDropdownItemsDefaultWrapper isOpen={isOpen} setOpen={handleOpenChange} buttonRef={buttonRef}>{t16}</CommonDropdownItemsDefaultWrapper>;
    $[44] = handleOpenChange;
    $[45] = isOpen;
    $[46] = t16;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== drop || $[49] !== isDeleteModalOpen) {
    t18 = isDeleteModalOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-50" elementRole="dialog" onClicked={_temp}><DropsListItemDeleteDropModal drop={drop} closeModal={() => setIsDeleteModalOpen(false)} /></CommonAnimationOpacity>;
    $[48] = drop;
    $[49] = isDeleteModalOpen;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  let t19;
  if ($[51] !== t18) {
    t19 = <CommonAnimationWrapper mode="sync" initial={true}>{t18}</CommonAnimationWrapper>;
    $[51] = t18;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  let t20;
  if ($[53] !== t17 || $[54] !== t19 || $[55] !== t8 || $[56] !== t9) {
    t20 = <>{t8}{t9}{t17}{t19}</>;
    $[53] = t17;
    $[54] = t19;
    $[55] = t8;
    $[56] = t9;
    $[57] = t20;
  } else {
    t20 = $[57];
  }
  return t20;
}
function _temp(e) {
  return e.stopPropagation();
}